<div class="modal-header" *ngIf="!isLoading.form">
  <h3 class="modal-title">{{ 'payment-approval-view.paymentOrder' | transloco }} {{ paymentApproval.number }} {{ 'payment-approval-view.from' | transloco }} {{ paymentApproval.date | date:'dd.MM.yyyy' }}
    <span class="m-badge m-badge--{{ statusOptions.get(paymentApproval.status)?.badge }} m-badge--wide m-badge--rounded m--margin-bottom-5 m--margin-left-15">
              {{ 'paymentApproval.status.' + paymentApproval.status | transloco }}
  </span>
  </h3>

  <button class="close" type="button" (click)="dismissModal()">
    <span>×</span>
  </button>
</div>

<div class="modal-body" *ngIf="isLoading.form">
  <div class="m-page-loader m-page-loader--non-block m-page-loader--relative">
    <div class="m-loader m-loader--brand"></div>
  </div>
</div>

<div class="modal-body" *ngIf="!isLoading.form">
  <div class="m-portlet__body">
    <div class="m-form__section m-form__section--first m-form--label-align-right">
      <div class="form-group m-form__group row">
        <label class="col-form-label col-lg-3 col-sm-12 ">
          {{ 'payment-approval-view.shop' | transloco }}:
        </label>

        <div class="col-lg-8 col-md-8 col-sm-12 m--margin-top-10">
          {{ paymentApproval.store.title | uiLabel }}
        </div>
      </div>

      <div class="form-group m-form__group row">
        <label class="col-form-label col-lg-3 col-sm-12">
          {{ 'payment-approval-view.supplier' | transloco }}:
        </label>

        <div class="col-lg-8 col-md-8 col-sm-12 m--margin-top-10">
          {{ paymentApproval.supplier.name }} ({{ paymentApproval.supplier.uin }})
        </div>
      </div>

      <div class="form-group m-form__group row">
        <label class="col-form-label col-lg-3 col-sm-12">
          {{ 'payment-approval-view.bank' | transloco }}:
        </label>

        <div class="col-lg-8 col-md-8 col-sm-12 m--margin-top-10">
          {{ paymentApproval.bankAccount?.iban }}
        </div>
      </div>

      <div class="form-group m-form__group row">
        <label class="col-form-label col-lg-3 col-sm-12">
          {{ 'payment-approval-view.knp' | transloco }}:
        </label>

        <div class="col-lg-2 col-md-2 col-sm-12 m--margin-top-10">
          {{ paymentApproval.paymentDestinationCode }}
        </div>
      </div>

      <div class="form-group m-form__group row" *ngIf="paymentApproval.note">
        <label class="col-form-label col-lg-3 col-sm-12">
          {{ 'payment-approval-view.note' | transloco }}:
        </label>

        <div class="col-lg-8 col-md-8 col-sm-12 m--margin-top-10">
          {{ paymentApproval.note }}
        </div>
      </div>

      <div class="m-form__section">
        <div class="form-group m-form__group form-group m-form__group--colored m-form__group--last m-form__group--first"
          *ngFor="let item of paymentApproval.invoicePayments;">
          <ng-container>
            <div class="row m--padding-bottom-15">
              <div class="col-lg-4 col-md-4 col-sm-3">
                <small>{{ 'payment-approval-view.overhead' | transloco }}:</small>
                <div>№{{ item.invoice.incomingInvoiceNumber }} {{ 'payment-approval-view.from' | transloco }} {{ item.invoice.incomingInvoiceDate | date:'dd.MM.yyyy' }}</div>
              </div>

              <div class="col-lg-2 col-md-2">
                <small>{{ 'payment-approval-view.totalSum' | transloco }}:</small>
                <div>{{ item.invoice.totalPrice | uiCurrency:item.invoice?.currency }}</div>
              </div>

              <div class="col-lg-3 col-md-3 col-sm-3">
                          <span class="d-inline-block" style="vertical-align: middle;">
                            <small>{{ 'payment-approval-view.sumPaid' | transloco }}:</small>
                            <div>{{ item.value | uiCurrency:item.invoice?.currency }}</div>
                          </span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="form-group m-form__group row">
        <label class="col-form-label col-lg-3 col-sm-12">
          {{ 'payment-approval-view.totalSumPaid' | transloco }}:
        </label>

        <div class="col-lg-3 col-md-3 col-sm-12 m--margin-top-10">
          {{ paymentApproval.total }}
        </div>
      </div>

      <div class="form-group m-form__group row" *ngIf="paymentApproval.cancelReason">
        <label class="col-form-label col-lg-3 col-sm-12">
          {{ 'payment-approval-view.cancel' | transloco }}:
        </label>

        <div class="col-lg-3 col-md-3 col-sm-12 m--margin-top-10">
          {{ paymentApproval.cancelReason }}
        </div>
      </div>


      <table class="table m--margin-bottom-0" *ngIf="events && events.length > 0">
        <thead class="thead-default">
        <tr>
          <th>{{ 'payment-approval-view.table.head.info' | transloco }}</th>
        </tr>
        </thead>
      </table>

      <div class="is--responsive-table" *ngIf="events && events.length > 0">
        <table class="hc-table">
          <thead class="hc-table__head">
          <tr class="hc-table__row hc-table__row--head">
            <td class="hc-table__cell">{{ 'payment-approval-view.table.head.date' | transloco }}</td>
            <td class="hc-table__cell">{{ 'payment-approval-view.table.head.author' | transloco }}</td>
            <td class="hc-table__cell">{{ 'payment-approval-view.table.head.note' | transloco }}</td>
            <td class="hc-table__cell">{{ 'payment-approval-view.table.head.status' | transloco }}</td>
          </tr>
          </thead>

          <tbody class="hc-table__body" *ngFor="let event of events">
          <tr class="hc-table__tow">
            <td class="hc-table__cell">
              <span>{{event.date | date: 'dd.MM HH:mm' }}</span>
            </td>
            <td class="hc-table__cell">
              <span [title]="event.actorFullName + ' - ' + event.actor">{{ event.actorFullName | fio }}</span>
            </td>
            <td class="hc-table__cell">
              {{ event.info }}
            </td>
            <td class="hc-table__cell">
                          <span class="m-badge m-badge--{{ eventOptions.get(event.type)?.badge }} m-badge--wide m-badge--rounded">
                            {{ 'payment-approval.type.' + event.type | transloco }}
                          </span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
  <div class="modal-footer modal-footer--pad-right">
    <button type="button" (click)="dismissModal()" class="btn btn-secondary">
      {{ 'btn.cancel' | transloco }}
    </button>
  </div>
</div>
